import { BOLD_GROUP } from "./ActionType";
// import { httpClient } from "../../../utils/UtilHttpClient";
// import * as markersIcon from "../../assets/markersIcon";
import ServiceApi from "../../services/ServiceApi";
import MaxiInfraApi from "../../http-infra";
export const setRepairList = (item) => {
  return (dispatch, getState) => {
    dispatch({
      type: BOLD_GROUP.SET_REPAIR_LIST,
      payload: item,
    });
  };
};

export const setRepairDetail = (item) => {
  return (dispatch, getState) => {
    dispatch({
      type: BOLD_GROUP.SET_REPAIR_DETAIL,
      payload: item,
    });
  };
};

export const clearRepairDetail = () => {
  return (dispatch, getState) => {
    dispatch({
      type: BOLD_GROUP.CLEAR_REPAIR_DETAIL,
    });
  };
};

export const clearRepairPoint = () => {
  return (dispatch, getState) => {
    dispatch({
      type: BOLD_GROUP.CLEAR_REPAIR_POINT,
    });
  };
};

export const getRepairPoint = (jobData) => {
  return async (dispatch, getState) => {
    try {
      const { data: res } = await ServiceApi.get(
        `repairpoint/getrepairpointbyid?jobID=${jobData.job_id}`
      );
      if (res.result.code === "P") {
        const { data } = res;
        dispatch({
          type: BOLD_GROUP.SET_REPAIR_LIST,
          payload: data.map((m) => ({ ...m, active: 1 })),
        });

        dispatch({
          type: BOLD_GROUP.SET_REPAIR_JOB_DETAIL,
          payload: jobData,
        });

        dispatch({
          type: BOLD_GROUP.CLEAR_REPAIR_DETAIL,
        });

        // setMarkers(reduceMarkers);
        // setPolylines(reducePolylines);
        // setIsLoading(false);
        // setRepairData(data.map((m) => ({ ...m, active: 1 })));
        // setDefaultLatLng({
        //   lat: data[0].markers[0].latitude,
        //   lng: data[0].markers[0].longitude,
        // });
        // setTypeActive(data.map((m) => m.repairPointID));
      } else {
        // notification.error({
        //   message: "เกิดข้อผิดพลาด",
        //   description: res.result.showText,
        // });
      }
    } catch (error) {}
  };
};

export const saveRepairPoint = (request) => {
  return async (dispatch, getState) => {
    const {
      repairPoint: { jobDetail },
    } = getState();
    try {
      const { data: res } = await ServiceApi.post(
        "repairpoint/setrepairpoint",
        [
          {
            ...request,
            companyID: jobDetail.company_id,
            operatorID: jobDetail.operator_id,
            projectID: jobDetail.project_id,
            jobID: jobDetail.job_id,
            userName: jobDetail.userName,
          },
        ]
      );
      if (res.result.code === "P") {
        dispatch(getRepairPoint(jobDetail));
      } else {
        throw { message: res.result.showText };
      }
    } catch (error) {
      throw error;
    }
  };
};

export const updateLayerDetail = (layerDetail) => {
  return async (dispatch, getState) => {
    const {
      repairPoint: { jobDetail },
    } = getState();
    try {
      const { data: res } = await ServiceApi.post(
        `repairpoint/updatelayerdetail?userName=${layerDetail.userName}`,
        layerDetail
      );
      if (res.result.code === "P") {
        dispatch(getRepairPoint(jobDetail));
      } else {
        throw { message: res.result.showText };
      }
    } catch (error) {
      throw error;
    }
  };
};

export const setCenterMap = (item) => {
  return (dispatch, getState) => {
    dispatch({
      type: BOLD_GROUP.SET_CENTER_MAP,
      payload: item,
    });
  };
};

export const getCoverageAutoRoute = (item) => {
  return async (dispatch, getState) => {
    try {
      const { data: res } = await MaxiInfraApi.post(`GetCoverageAutoRoute`, {
        lat: item.latitude,
        lng: item.longitude,
        dist: "1",
        typeselect: [item.layerType],
        fiberRouteId : item.fiberRouteId,
        area: "",
        fromOper: true,
      });
      if (res.Result.Code === "P") {
        // console.log("res", res);
        dispatch({
          type: BOLD_GROUP.SET_COVERAGE,
          payload: res.Data,
        });
        // dispatch(getRepairPoint(jobDetail));
      } else {
        // console.log("res.Result.showText", res.Result.ShowText);
        dispatch({
          type: BOLD_GROUP.SET_COVERAGE,
          payload: [],
        });
        throw { message: res.Result.ShowText };
      }
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: BOLD_GROUP.SET_CENTER_MAP,
    //   payload: item,
    // });
  };
};

export const getCoverageFibers = (siteCode) => {
  return async (dispatch, getState) => {
    try {
      // const {
      //   repairPoint: { repairDetail },
      // } = getState();

      // const originSite = repairDetail.markers.find(
      //   (f) => f.stationCode === 1 && f.layerCode === "SITE"
      // );
      // const destinationSite = repairDetail.markers.find(
      //   (f) => f.stationCode === 2 && f.layerCode === "SITE"
      // );

      // console.log("originSite", originSite);
      // console.log("destinationSite", destinationSite);

      let resFibers = [];

      const { data: res } = await MaxiInfraApi.post(`GetListRoute`, {
        area: "",
        routeType: "ALL",
        // siteCode: "CCO-5011-UC",
        siteCode: siteCode,
      });
      if (res.Result.Code === "P") {
        resFibers = [
          ...res.Data.networkfiber,
          ...res.Data.cus_fiber,
          ...res.Data.copper_ap,
          ...res.Data.copper_dw,
          ...res.Data.accessfiber,
          ...res.Data.networkfiber_sr,
          ...res.Data.networkdarkfiber,
          ...res.Data.networkunderground,
        ];
        const convertLatlng = resFibers.map((item) => {
          const splitFiber = item.LATLON?.split("@");

          const newCoordinate = splitFiber.map((s) => {
            const splitLatLng = s.split(",");
            return {
              lat: +splitLatLng[1],
              lng: +splitLatLng[0],
            };
          });
          return { ...item, coordinate: newCoordinate };
        });
        dispatch({
          type: BOLD_GROUP.SET_COVERAGE_ROUTE,
          payload: convertLatlng,
        });
      } else {
        dispatch({
          type: BOLD_GROUP.SET_COVERAGE_ROUTE,
          payload: [],
        });
        throw { message: res.Result.ShowText };
      }

      // if (destinationSite.latitude && destinationSite.longitude) {
      //   const { data: resDestination } = await MaxiInfraApi.post(
      //     `GetListRoute`,
      //     {
      //       area: "",
      //       routeType: "ALL",
      //       siteCode: "CCO-5011-UC",
      //       // siteCode: destinationSite.siteCode,
      //     }
      //   );
      //   if (resDestination.Result.Code === "P") {
      //     resFibers = [...resFibers, ...resDestination.Data.networkfiber];
      //   }
      // }
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: BOLD_GROUP.SET_CENTER_MAP,
    //   payload: item,
    // });
  };
};

export const setCoverageFibers = (playload) => {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: BOLD_GROUP.SET_COVERAGE_ROUTE,
        payload: playload,
      });
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: BOLD_GROUP.SET_CENTER_MAP,
    //   payload: item,
    // });
  };
};

export const GetDevicesOdfMdf = (item) => {
  return async (dispatch, getState) => {
    try {
      // const { data: res } = await MaxiInfraApi.get(`GetOdfMdfNodeDetail/20170927185544/site`);
      const { data: res } = await MaxiInfraApi.get(`GetOdfMdfNodeDetail/${item.pkId}/site`);
      // console.log("res", res);
      if (res.Result.Code === "P") {
        // console.log("res", res);
        dispatch({
          type: BOLD_GROUP.SET_ACCESSORY_ODF_MDF,
          payload: res.Data,
        });
        // dispatch(getRepairPoint(jobDetail));
      } else {
        // console.log("res.Result.showText", res.Result.ShowText);
        dispatch({
          type: BOLD_GROUP.SET_ACCESSORY_ODF_MDF,
          payload: [],
        });
        throw { message: res.Result.ShowText };
      }
    } catch (error) {
      throw error;
    }
    // dispatch({
    //   type: BOLD_GROUP.SET_CENTER_MAP,
    //   payload: item,
    // });
  };
};

export const decode = (t, e) => {
  for (
    var n,
      o,
      u = 0,
      l = 0,
      r = 0,
      d = [],
      h = 0,
      i = 0,
      a = null,
      c = Math.pow(10, e || 5);
    u < t.length;

  ) {
    a = null;
    h = 0;
    i = 0;
    do {
      a = t.charCodeAt(u++) - 63;
      i |= (31 & a) << h;
      h += 5;
    } while (a >= 32);
    n = 1 & i ? ~(i >> 1) : i >> 1;
    h = i = 0;
    do {
      a = t.charCodeAt(u++) - 63;
      i |= (31 & a) << h;
      h += 5;
    } while (a >= 32);
    o = 1 & i ? ~(i >> 1) : i >> 1;
    l += n;
    r += o;
    d.push([l / c, r / c]);
  }
  return (d = d.map(function (t) {
    return { latitude: t[0], longitude: t[1] };
  }));
};
